<template lang="pug">
  .manageTimezones
    //- Barra de navegación
    van-nav-bar(
      :title="$t('addUnit.unit.addGroup')"
      left-arrow
      @click-left="$emit('closeView')"
    )

    div(v-if="!isLoading")

      //- Buscador de timezones
      van-search(
        :placeholder="$t('addUnit.unit.searchZone')"
        v-model="timezoneSearch")

      .main.margin-double-top
        van-cell-group()
          //- Listado de timezones
          van-cell(
            v-for="(zone, key) in timezonesFilter"
            :title="zone"
            :key="key"
            @click="setTimezone(zone)")
            van-icon(
              v-if="zone === timezone"
              slot="right-icon"
              name="save"
              class="van-cell__right-icon text-brand")
</template>

<script>
import i18n from '@/locales/i18n';
import { getErrorId } from '@/services/error.service';
import InstallationService from '@/services/installation.service';

export default {
  name: 'ManageTimezones',
  data() {
    return {
      timezones: null,
      timezoneSearch: '',
      isLoading: false,
      timezoneError: null,
    };
  },

  props: {
    timezone: {
      type: String,
      default: '',
    },
  },

  computed: {
    timezonesFilter() {
      if (!this.timezones) return null;

      return this.timezones.filter(timezone => {
        return timezone.toLowerCase().includes(this.timezoneSearch.toLowerCase());
      });
    },
  },
  methods: {
    /**
     * Obtiene un listado con los timezones
     */
    async getTimezones() {
      try {
        // Compruebo si hay una petición en curso,
        // si la hay, no hago nada
        if (this.isLoading) return;

        // Muestro el loader
        this.$toast.loading({
          duration: 0,
          mask: true,
          message: i18n.t('general.loading'),
        });

        // Inicializo valores
        this.isLoading = true;
        this.timezoneError = null;

        // Realizo la petición
        this.timezones = await InstallationService.getTimezones();
        this.$toast.clear();
      } catch (error) {
        // Obtengo el error
        this.authError = getErrorId(error);

        this.$toast.clear();
        this.$toast.fail({ mask: true, message: i18n.t('general.errors.default.message') });
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Lanza un evento con el timezone seleccionado
     */
    setTimezone(timezone) {
      this.timezoneSearch = '';
      this.$emit('timezone', timezone);
    },
  },

  created() {
    this.getTimezones();
  },
};
</script>
